import './App.css';
import { useEffect, useState } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase-config';

import Header from './components/Header';
import HeroSection from './components/HeroSection/HeroSection';
import OlaSection from './components/OlaSection/OlaSection';
import FeatureSection from './components/FeatureSection/FeatureSection';
import ServicesSection from './components/ServicesSection/ServicesSection';
import ExploreSection from './components/ExploreSection/ExploreSection';
import ContactSection from './components/ContactSection/ContactSection';
import FooterSection from './components/FooterSection/FooterSection';
import SaybicDashboard from './components/SaybicInnovation/SaybicDashboard';
import ContactCard from './components/ContactCard/ContactCard';
import TsContasolLanding from './components/TsContasolLanding/TsContasolLanding';
import EcommerceAuditLanding from './components/EcommerceAuditLanding/EcommerceAuditLanding';

//import Login from './components/Login';
import LoginForm from "./components/LoginForm";


function App() {
  const [user, setUser] = useState(null);
  const path = window.location.pathname;

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  // Ruta SayBiC
  if (path === '/saybic-innovation') {
    return (
      <div className="App">
        {user ? <SaybicDashboard /> : <LoginForm />}
      </div>
    );
  }

  // Ruta tarjeta de contacto
  if (path === '/contact-card') {
    return (
      <div className="App">
        <ContactCard />
      </div>
    );
  }

  if (path === '/ts-contasol') {
    return (
      <div className="App">
        {/* Wrapper que actuará como reseteador de estilos */}
        <div className="ts-contasol-wrapper">
          <TsContasolLanding />
          <FooterSection />
        </div>
      </div>
    );
  }

  if (path === '/auditoria-ecommerce') {
    return (
      <div className="App">
        <EcommerceAuditLanding />
      </div>
    );
  }

  return (
    <div className="App">
      <div className='main-content'>
        <div className='container-fluid'>
          <div className='custom-container px-lg-5 px-md-4 px-sm-2'>
            <div className='row'>
              <div className='col-12'>
                <Header />
              </div>
            </div>
          </div>
          <div className='col-lg-12'>
            <HeroSection />
          </div>
          <div className='col-lg-12'>
            <OlaSection />
          </div>
          <div className='col-lg-12'>
            <FeatureSection />
          </div>
          <div className='col-lg-12'>
            <ServicesSection />
          </div>
          <div className='col-lg-12'>
            <ExploreSection />
          </div>
          <div className='col-lg-12'>
            <ContactSection />
          </div>
          <div className='col-lg-12'>
            <FooterSection />
          </div>
        </div>
      </div>
    </div>
  );
}

export default App;
// En este código, hemos añadido un estado `user` que se actualiza cada vez que cambia el estado de autenticación del usuario.
// Si el usuario está autenticado, se muestra el componente `SaybicDashboard`, de lo contrario, se muestra el componente `Login`. 
